module.exports = __webpack_public_path__ + "media/icons/calendar-8b8d1ee6.svg";